module.exports = __webpack_public_path__ + "static/media/home.8c5db54c.jpg";